import React, { useEffect, useState } from "react";
import { AreaChart, Area, ResponsiveContainer, Tooltip, XAxis, YAxis, CartesianGrid } from "recharts";
import { Dropdown } from "react-bootstrap";
import Styles from "./weekly.module.css";
import { useDispatch } from "react-redux";
import { getSalesHistoryAction } from "../../../store/actions/dashboard/DashboardActions";
import ShimmerLoader from "../../pages/ShimmerLoader/ShimmerLoader";
import currenyFormat from "../common/currentFormat";

const WeeklySalesReportGraph = React.memo(() => {
  const dispatch = useDispatch();
  const [selectedOption, setSelectedOption] = useState("Yearly");
  const [dateRange, setDateRange] = useState("");
  const [salesHistory, setSalesHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  const options = {
    Weekly: "1W",
    Monthly: "1M",
    Yearly: "1Y",
  };

  const handleSelect = (eventKey) => {
    setSelectedOption(eventKey);
  };

  useEffect(() => {
    const userData = localStorage.getItem("userDetails");
    const parsedData = JSON.parse(userData);
    let isSalesDatePermisssion = parsedData.role_permissions.sales_data;
    if (isSalesDatePermisssion) {
      const payload = {
        timeFrame: options[selectedOption],
      };

      const fetchSalesHistory = async () => {
        try {
          setLoading(true);
          const response = await getSalesHistoryAction(payload);
          setSalesHistory(response.result.data);
          setLoading(false);
        } catch (error) {
          setLoading(false);
          console.error("Failed to fetchSalesHistory:", error);
        }
      };
      fetchSalesHistory();

      const endDate = new Date();
      const startDate = new Date();

      switch (selectedOption) {
        case "Weekly":
          startDate.setDate(endDate.getDate() - 7);
          break;
        case "Monthly":
          startDate.setMonth(endDate.getMonth() - 1);
          break;
        case "Yearly":
          startDate.setFullYear(endDate.getFullYear() - 1);
          break;
        default:
          break;
      }

      const formattedStartDate = formatDate(startDate);
      const formattedEndDate = formatDate(endDate);
      setDateRange(`(${formattedStartDate} - ${formattedEndDate})`);
    } else {
      setSalesHistory([]);
      setDateRange("");
      setLoading(false);
    }
  }, [dispatch, selectedOption]);

  const formatDate = (date) => {
    const options = { day: "numeric", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-IN", options).replace(",", "").replace(" ", " ");
  };

  const generateStaticData = () => {
    const data = [];
    const today = new Date();
    for (let i = 7; i >= 0; i--) {
      const date = new Date();
      date.setDate(today.getDate() - i);
      data.push({
        total_sales: 0,
        transaction_date: date.toISOString().split("T")[0],
      });
    }
    return data;
  };

  const transformedSalesHistory =
    salesHistory.length > 0
      ? salesHistory.map((item) => ({
          "Transaction Date": formatDate(new Date(item.transaction_date)),
          "Total Sales": item.total_sales, // Keep it as a number for the chart
        }))
      : generateStaticData().map((item) => ({
          "Transaction Date": formatDate(new Date(item.transaction_date)),
          "Total Sales": item.total_sales, // Keep it as a number for the chart
        }));

  return (
    <>
      <div className="card-header border-0 pb-0">
        <h4 className={`${Styles.main_hearer}`}>Sales History {dateRange}</h4>
        <Dropdown className="pb-2" onSelect={handleSelect}>
          <Dropdown.Toggle variant="" as="div" className={`cursor-pointer fs-12 ${Styles.formControl}`}>
            {selectedOption}
          </Dropdown.Toggle>
          <Dropdown.Menu alignRight className="dropdown-menu-right">
            {Object.keys(options).map((key) => (
              <Dropdown.Item key={key} eventKey={key}>
                {key}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <div className="card-body">
        {loading ? (
          <ShimmerLoader width="50%" height="10%" count={2} />
        ) : (
          <ResponsiveContainer width="100%" aspect={4.0 / 2.0}>
            <AreaChart data={transformedSalesHistory} margin={{ top: 10, right: 38, left: 20, bottom: 20 }}>
              <defs>
                <linearGradient id="colorGold" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#E0A33E" stopOpacity={0.9} />
                  <stop offset="95%" stopColor="#E0A33E" stopOpacity={0.2} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke="#ddd" />
              <XAxis
                dataKey="Transaction Date"
                axisLine={{ stroke: "#ccc" }}
                tick={{ fill: "#666", fontFamily: "'Poppins', sans-serif", dy: 15 }}
                tickLine={{ stroke: "#ccc" }}
              />
              <YAxis
                axisLine={{ stroke: "#ccc" }}
                tick={{ fill: "#666", fontFamily: "'Poppins', sans-serif" }}
                tickLine={{ stroke: "#ccc" }}
                // tickFormatter={(value) => `${value.toFixed(2)}`} // Add ₹ symbol to Y-axis
                tickFormatter={(value) => `${currenyFormat(value)}`}
              />
              <Tooltip
                // formatter={(value) => [`₹ ${value.toFixed(2)}`, "Total Sales"]} // Add ₹ symbol to tooltip
                formatter={(value) => [`${currenyFormat(value)}`, "Total Sales"]}
              />
              <Area type="monotone" dataKey="Total Sales" stroke="#E0A33E" strokeWidth={3} fill="url(#colorGold)" />
            </AreaChart>
          </ResponsiveContainer>
        )}
      </div>
    </>
  );
});

export default WeeklySalesReportGraph;

// import React, { useEffect, useState } from "react";
// import { AreaChart, Area, ResponsiveContainer, Tooltip, XAxis, YAxis, CartesianGrid } from "recharts";
// import { Dropdown } from "react-bootstrap";
// import Styles from "./weekly.module.css";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { getSalesHistoryAction } from "../../../store/actions/dashboard/DashboardActions";
// import ShimmerLoader from "../../pages/ShimmerLoader/ShimmerLoader";

// const WeeklySalesReportGraph = React.memo(() => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const [selectedOption, setSelectedOption] = useState("Yearly");
//   const [dateRange, setDateRange] = useState("");
//   const [salesHistory, setSalesHistory] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const options = {
//     Weekly: "1W",
//     Monthly: "1M",
//     Yearly: "1Y",
//     // "Half Yearly": "6M",
//     // "3Y": "3Y",
//     // "5Y": "5Y",
//   };

//   const handleSelect = (eventKey) => {
//     setSelectedOption(eventKey);
//   };

//   useEffect(() => {
//     const payload = {
//       timeFrame: options[selectedOption],
//     };

//     const fetchSalesHistory = async () => {
//       try {
//         setLoading(true);
//         const response = await getSalesHistoryAction(payload);
//         setSalesHistory(response.result.data);
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         console.error("Failed to fetchSalesHistory:", error);
//       }
//     };
//     fetchSalesHistory();

//     const endDate = new Date();
//     const startDate = new Date();

//     switch (selectedOption) {
//       case "Weekly":
//         startDate.setDate(endDate.getDate() - 7);
//         break;
//       case "Monthly":
//         startDate.setMonth(endDate.getMonth() - 1);
//         break;
//       case "Half Yearly":
//         startDate.setMonth(endDate.getMonth() - 6);
//         break;
//       case "Yearly":
//         startDate.setFullYear(endDate.getFullYear() - 1);
//         break;
//       case "3Y":
//         startDate.setFullYear(endDate.getFullYear() - 3);
//         break;
//       case "5Y":
//         startDate.setFullYear(endDate.getFullYear() - 5);
//         break;
//       default:
//         break;
//     }

//     const formattedStartDate = formatDate(startDate);
//     const formattedEndDate = formatDate(endDate);
//     setDateRange(`(${formattedEndDate} - ${formattedStartDate})`);
//   }, [dispatch, selectedOption]);

//   const formatDate = (date) => {
//     const options = { day: "numeric", month: "short", year: "numeric" };
//     return date.toLocaleDateString("en-IN", options).replace(",", "").replace(" ", " ");
//   };

//   const generateStaticData = () => {
//     const data = [];
//     const today = new Date();
//     for (let i = 7; i >= 0; i--) {
//       const date = new Date();
//       date.setDate(today.getDate() - i);
//       data.push({
//         total_sales: 0,
//         transaction_date: date.toISOString().split("T")[0],
//       });
//     }
//     return data;
//   };

//   const transformedSalesHistory =
//     salesHistory.length > 0
//       ? salesHistory.map((item) => ({
//           "Transaction Date": formatDate(new Date(item.transaction_date)),
//           "Total Sales": item.total_sales.toFixed(2),
//         }))
//       : generateStaticData().map((item) => ({
//           "Transaction Date": formatDate(new Date(item.transaction_date)),
//           "Total Sales": item.total_sales.toFixed(2),
//         }));

//   return (
//     <>
//       <div className='card-header border-0 pb-0'>
//         <h4 className={`${Styles.main_hearer}`}>Sales History {dateRange}</h4>
//         <Dropdown className='mt-1' onSelect={handleSelect}>
//           <Dropdown.Toggle variant='' as='div' className='cursor-pointer fs-12'>
//             {selectedOption}
//           </Dropdown.Toggle>
//           <Dropdown.Menu alignRight className='dropdown-menu-right'>
//             {Object.keys(options).map((key) => (
//               <Dropdown.Item key={key} eventKey={key}>
//                 {key}
//               </Dropdown.Item>
//             ))}
//           </Dropdown.Menu>
//         </Dropdown>
//       </div>

//       <div className='card-body'>
//         {loading ? (
//           <ShimmerLoader width='50%' height='10%' count={2} />
//         ) : (
//           <ResponsiveContainer width='100%' aspect={4.0 / 2.0}>
//             <AreaChart data={transformedSalesHistory} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
//               <defs>
//                 <linearGradient id='colorGold' x1='0' y1='0' x2='0' y2='1'>
//                   <stop offset='5%' stopColor='#E0A33E' stopOpacity={0.9} />
//                   <stop offset='95%' stopColor='#E0A33E' stopOpacity={0.2} />
//                 </linearGradient>
//               </defs>
//               <CartesianGrid strokeDasharray='3 3' stroke='#ddd' />
//               <XAxis dataKey='Transaction Date' axisLine={{ stroke: "#ccc" }} tick={{ fill: "#666", fontFamily: "'Poppins', sans-serif" }} tickLine={{ stroke: "#ccc" }} />
//               <YAxis axisLine={{ stroke: "#ccc" }} tick={{ fill: "#666", fontFamily: "'Poppins', sans-serif" }} tickLine={{ stroke: "#ccc" }} />
//               <Tooltip />
//               <Area type='monotone' dataKey='Total Sales' stroke='#E0A33E' strokeWidth={3} fill='url(#colorGold)' />
//             </AreaChart>
//           </ResponsiveContainer>
//         )}
//       </div>
//     </>
//   );
// });

// export default WeeklySalesReportGraph;
